export default __webpack_public_path__ + "static/media/interior6.5ba261ab.webp";